module.exports = __webpack_public_path__ + "static/img/zhenoloss.96106d8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/geren/photos/zhenoloss.jpeg
// module id = ER4F
// module chunks = 36